<template>
  <div id="ctm_valor_detalle">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col xs="12">
          <base-material-card
            color="primary"
            icon="library_books"
            title="Reporte Resumen de Relación CFDI a CTM"
            class="elevation-1 px-5 py-3"
          >
            <br />
            <v-tabs grow style="margin-bottom: 30px;">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab :key="'in-view'">Vista Previa</v-tab>
              <v-tab :key="'in-report'">Generar en Reporte</v-tab>

              <v-tab-item :key="'in-view'">
                <v-card-text>
                  <v-card-title>
                    <span class="headline"></span>
                  </v-card-title>
                  <v-form ref="form1" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col sm="12" md="3" lg="3">
                          <v-menu
                            offset-x
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="model.periodo_de"
                                label="Periodo Inicial"
                                color="secondary"
                                prepend-icon="event"
                                :rules="[verificaPedimento, verificaTipoConsulta, validaAnio, validaFecha]"
                              >
                              </v-text-field>
                            </template>

                            <v-date-picker
                              v-model="model.periodo_de"
                              color="secondary"
                              scrollable
                              locale="es-mx"
                              @input="menu1 = false"
                              type="month"
                            >
                              <v-spacer />

                              <v-btn
                                color="secondary"
                                x-small
                                @click="menu1 = false"
                              >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="3" lg="3">
                          <v-menu
                            offset-x
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="model.periodo_a"
                                label="Periodo Final"
                                color="secondary"
                                prepend-icon="event"
                                :rules="[verificaPedimento, verificaTipoConsulta, validaAnio, validaFecha]"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="model.periodo_a"
                              color="secondary"
                              scrollable
                              locale="es-mx"
                              @input="menu2 = false"
                              type="month"
                            >
                              <v-spacer />

                              <v-btn
                                color="secondary"
                                x-small
                                @click="menu2 = false"
                              >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                          <v-col sm="12" md="2" lg="2" style="margin-top:-35px;">
                              <v-radio-group v-model="model.tipo_consulta" label="Tipo de Listado:">
                              <v-radio label="No. de Folio" value="folios" />
                              <v-radio label="No. de Parte" value="partes" />                                            
                              </v-radio-group>
                          </v-col>
                          <v-col sm="12" md="1" lg="1">
                              <v-btn icon :title="'Buscar por'+ (model.tipo_consulta=='folios'?' Folio CTM':' No. Parte')" @click="dialog1 = !dialog1" v-tippy>
                              <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                              </v-btn>
                          </v-col>                            
                          <v-col sm="12" md="2" lg="2">
                              Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                          </v-col>
                          <v-col sm="12" md="7" lg="7">
                              <v-combobox v-model="lista_filtrada" :label="'Lista de'+ (model.tipo_consulta=='folios'?' Folios CTM':' No. Partes')" multiple persistent-hint small-chips disabled color="green">
                              </v-combobox>
                          </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    color="success"
                    @click="get_data_view()"
                    :loading="loading"
                  >
                    <v-icon>done</v-icon>Vista Previa
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <exportar-excel
                      v-show="data_view.datos.length"
                      :data="data_view.datos"
                      :exportFields="encabezados_excel"
                      name="VistaPrevia_Resumen_Relacion_CFDI_CTM.xlsx">
                      <v-btn fab sark x-small color="green darken-1" title="Exportar" v-tippy>
                          <v-icon dark>mdi-file-excel</v-icon>
                      </v-btn>
                  </exportar-excel>
                  <v-client-table
                    ref="vuetable"
                    :data="data_view.datos"
                    :columns="data_view.columns"
                    :options="data_view.options"
                    class="elevation-2 pa-2 scroll-table"
                  >
                    <template slot="noResults">
                      <v-alert :value="true" icon="info" color="info"
                        >No se encontro ningun registro</v-alert
                      >
                    </template>
                    
                    <template slot="cantidad_cfdi" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDecCero(props.row.cantidad_cfdi,2)}}</div>
                    </template>                    
                    <template slot="precio_unitario" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDecCero(props.row.precio_unitario,2)}}</div>
                    </template>
                    <template slot="valor_cfdi" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDecCero(props.row.valor_cfdi,2)}}</div>
                    </template>
                    <template slot="cantidad_ctm" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDecCero(props.row.cantidad_ctm,2)}}</div>
                    </template>
                    <template slot="valor_ctm" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDecCero(props.row.valor_ctm,2)}}</div>
                    </template>
                    <template slot="saldo_cantidad_ctm" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDecCero(props.row.saldo_cantidad_ctm,2)}}</div>
                    </template>
                    <template slot="saldo_valor_ctm" slot-scope="props">
                      <div style="text-align:right">{{formatNumberDecCero(props.row.saldo_valor_ctm,2)}}</div>
                    </template>
                    

                  </v-client-table>
                </v-card-text>
              </v-tab-item>
              <v-tab-item :key="'in-report'">
                <v-card-text>
                  <v-card-title>
                    <span class="headline"></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col sm="12" md="3" lg="3">
                          <v-menu
                            offset-x
                            ref="menu3"
                            v-model="menu3"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="model.periodo_de"
                                label="Periodo Inicial"
                                color="secondary"
                                prepend-icon="event"
                                :rules="[verificaPedimento, verificaTipoConsulta, validaAnio, validaFecha]"
                              >
                              </v-text-field>
                            </template>

                            <v-date-picker
                              v-model="model.periodo_de"
                              color="secondary"
                              scrollable
                              locale="es-mx"
                              @input="menu3 = false"
                              type="month"
                            >
                              <v-spacer />

                              <v-btn
                                color="secondary"
                                x-small
                                @click="menu3 = false"
                              >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="3" lg="3">
                          <v-menu
                            offset-x
                            ref="menu4"
                            v-model="menu4"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="model.periodo_a"
                                label="Periodo Final"
                                color="secondary"
                                prepend-icon="event"
                                :rules="[verificaPedimento, verificaTipoConsulta, validaAnio, validaFecha]"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="model.periodo_a"
                              color="secondary"
                              scrollable
                              locale="es-mx"
                              @input="menu4 = false"
                              type="month"
                            >
                              <v-spacer />

                              <v-btn
                                color="secondary"
                                x-small
                                @click="menu4 = false"
                              >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                          <v-col sm="12" md="2" lg="2" style="margin-top:-35px;">
                              <v-radio-group v-model="model.tipo_consulta" label="Tipo de Listado:">
                              <v-radio label="No. de Folio" value="folios" />
                              <v-radio label="No. de Parte" value="partes" />                                            
                              </v-radio-group>
                          </v-col>
                          <v-col sm="12" md="1" lg="1">
                              <v-btn icon :title="'Buscar por'+ (model.tipo_consulta=='folios'?' Folio CTM':' No. Parte')" @click="dialog1 = !dialog1" v-tippy>
                              <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                              </v-btn>
                          </v-col>                            
                          <v-col sm="12" md="2" lg="2">
                              Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                          </v-col>
                          <v-col sm="12" md="7" lg="7">
                              <v-combobox v-model="lista_filtrada" :label="'Lista de'+ (model.tipo_consulta=='folios'?' Folios CTM':' No. Partes')" multiple persistent-hint small-chips disabled color="green">
                              </v-combobox>
                          </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    rounded
                    color="success"
                    @click="generar_reporte_sqs"
                    :loading="loading"
                  >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargar" />

                  <v-client-table
                    ref="vuetable"
                    :data="datos"
                    :columns="columns"
                    :options="options"
                    class="elevation-2 pa-2"
                  >
                    <template slot="noResults">
                      <v-alert :value="true" icon="info" color="info"
                        >No se encontro ningun registro</v-alert
                      >
                    </template>

                    <template slot="actions" slot-scope="props">
                      <v-btn
                        text
                        icon
                        color="primary"
                        title="Descargar"
                        v-if="
                          props.row.estatus == 'Generado Correctamente' &&
                            props.row.filename != ''
                        "
                        @click="downloadReporte(props.row.filename)"
                      >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn
                        text
                        icon
                        color="red"
                        title="Eliminar"
                        v-if="permisoEliminar"
                        @click="eliminarReporte(props.row.id)"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </v-tab-item>
            </v-tabs>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  
  <v-dialog v-model="dialog1" max-width="500px">
      <v-card>
      <v-card-text>
          <h5>Ingrese lista de {{ (model.tipo_consulta=='folios'?' Folios CTM':' No. Partes')}}</h5>
          <span>Uno por línea</span><br>        
          <v-form ref="formListado" lazy-validation="">
          <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]"></v-textarea>
          </v-form>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="model.lista=''; lista_filtrada=[]; dialog1 = false">Cancelar</v-btn>
          <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
      </v-card-actions>
      </v-card>
  </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
  components: {
    "v-refresh-button": RefreshButton
  },
  created: function() {
    this.URL = this.$hostname + "reportes/";
    this.loading = false;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");

    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
      this.permisoEliminar = true;

    this.cargar();
  },
  data: () => ({
    permisoEliminar: false,
    tab: null,
    breadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "CTM",
        disabled: true,
        to: ""
      },
      {
        text: "Relación CFDI a CTM",
        disabled: true,
        to: ""
      }
    ],
    datos: [],
    columns: [
      "id",
      "fecha_solicitud",
      "usuario_email",
      "nombre_reporte",
      "criterio",
      "fecha_generacion",
      "estatus",
      "error",
      "actions"
    ],
    options: {
      filterable: [
        "id",
        "fecha_solicitud",
        "usuario_email",
        "nombre_reporte",
        "criterio",
        "fecha_generacion",
        "estatus",
        "error"
      ],
      sortable: [
        "id",
        "fecha_solicitud",
        "usuario_email",
        "nombre_reporte",
        "criterio",
        "fecha_generacion",
        "estatus",
        "error"
      ],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: true,
    show_loading: true,
    dialog1: false,
    lista_filtrada: [],
    model: {
      rfc: "",
      usuario: "",
      periodo_de: "",
      periodo_a: "",
      reporte_url: "/soluciona24/reportes/rpt_resumen_cfdi_ctm/",
      nombre_reporte: "Resumen CFDI a CTM",
      tipo: "Resumen CFDI a CTM",
      lista: '',                
      tipo_consulta: "folios", //folios|partes
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    encabezados_excel: {
        "Factura/CFDI":"cfdi",
        "Fecha":"fecha_cfdi",
        "Cliente":"cliente",
        "Material":"material",
        "Cantidad":"cantidad_cfdi",
        "PU":"precio_unitario",
        "Valor CFDI":"valor_cfdi",
        "Moneda":"moneda",
        "Cantidad Asociada a CTM":"cantidad_ctm",
        "Valor Asociado a CTM":"valor_ctm",
        "Cantidad sin Asociar a CMT":"saldo_cantidad_ctm",
        "Saldo sin Asociar a CTM":"saldo_valor_ctm",
    },
    data_view: {
      datos: [],
      columns: [
        "cfdi",
        "fecha_cfdi",
        "cliente",
        "material",
        "cantidad_cfdi",
        "precio_unitario",
        "valor_cfdi",
        "moneda",
        "cantidad_ctm",
        "valor_ctm",
        "saldo_cantidad_ctm",
        "saldo_valor_ctm",        
      ],
      options: {
        filterable: ["cfdi",
        "fecha_cfdi",
        "cliente",
        "material",
        "cantidad_cfdi",
        "moneda",
        "precio_unitario",
        "valor_cfdi",
        "cantidad_ctm",
        "valor_ctm",
        "saldo_cantidad_ctm",
        "saldo_valor_ctm",],
        sortable: ["cfdi",
        "fecha_cfdi",
        "cliente",
        "material",
        "cantidad_cfdi",
        "moneda",
        "precio_unitario",
        "valor_cfdi",
        "cantidad_ctm",
        "valor_ctm",
        "saldo_cantidad_ctm",
        "saldo_valor_ctm",],
        headings: {
          "cfdi":"Factura/CFDI",
          "fecha_cfdi":"Fecha",
          "cliente":"Cliente",
          "material":"Material",
          "cantidad_cfdi":"Cantidad",
          "moneda":"Moneda",
          "precio_unitario":"PU",
          "valor_cfdi":"Valor CFDI",
          "cantidad_ctm":"Cantidad Asociada a CTM",
          "valor_ctm":"Valor Asociado a CTM",
          "saldo_cantidad_ctm":"Cantidad sin Asociar a CMT",
          "saldo_valor_ctm":"Saldo sin Asociar a CTM",
        }
      }
    }
  }),
  methods: {
    setListValues: function() {
        this.lista_filtrada = [];
        let to_list = this.get_array_lista(this.model.lista);
        for (var i = 0; i < to_list.length; i++) {
            if (this.lista_filtrada.includes(to_list[i])) {
            continue;
            } else {
            this.lista_filtrada.push(to_list[i]);
            }
        }
        if(this.model.tipo_consulta == "folios"){//Que solo borre cuando sea busqueda por folios
          this.model.periodo_de = "";
          this.model.periodo_a = "";
        }
        this.dialog1 = !this.dialog1;
    },
    get_array_lista: function(cadena) {
        try {
            var newarr = [];
            if (cadena != undefined) {
            let data = cadena.split("\n");
            newarr = data.filter(a => a.trim() !== '');
            for (var i = 0; i < newarr.length; i++) {
                newarr[i] = newarr[i].trim();
                newarr[i] = newarr[i].replace(',', '');
                newarr[i] = newarr[i].replace('.', '');
            }
            }
            return newarr;
        } catch (error) {
            console.log(error);
        }
    },  
    verificaPedimento: function() {
        if (this.model.lista != '' && this.model.lista != null && this.model.lista.length > 0) {
            return true;
        }
        if (this.model.periodo_de == "" || this.model.periodo_a == "") {
            return "Favor de ingresar periodos o listado";
        }
        return true;
    },
    verificaTipoConsulta: function() {            
        if (this.model.tipo_consulta == "partes" && (this.model.periodo_de == "" || this.model.periodo_a == "")) {
            return "Favor de ingresar periodos cuando el listado es por No. Parte";
        }
        return true;
    },
    maxListaRule: function() {
        if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
            return "Lista vacia";
        }

        let x = this.model.lista.split("\n");

        if (x.length > 15) {
            return "No se puede consultar mas de 15 folios/no. partes";
        } /*else if (x.length > 0) {
            for (var k in x) {
            if (!this.validarPatronPedimento(x[k]))
                return "Verificar pedimentos no válidos. Ejemplo correcto: 15-07-0123-0000123";
            }
        }*/

        return true;
    },
    validaFecha: function(fecha) {
        if (fecha == "Invalid date")
            return "Fecha no válida.";
        else
            return true;
    },
    validaAnio: function() {
        if (this.model.periodo_de != "" && this.model.periodo_a != "") {
            var inicio = moment(this.model.periodo_de, "YYYY-MM-DD");
            var fin = moment(this.model.periodo_a, "YYYY-MM-DD");
            var diferencia = fin.diff(inicio, 'days')
            if (diferencia < 0)
                return "El Periodo Final no debe ser menor al Periodo Inicial."
            if (Math.abs(diferencia) > 366)
                return "Periodo máximo de consulta un año. Favor de verificar."
        }
        return true;
    },
    formatNumberDecCero: function(numero, decimales){
          if (numero == undefined || numero == null || numero == "")
              numero = 0;
          numero = Number(numero);
          if (isNaN(numero)){
              return "";
          } else{
            if(parseFloat(numero) == parseInt(numero))
              return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            else
              return (numero).toFixed(decimales).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }    
      },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    cargar: function() {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {
        rfc: this.model.rfc,
        tipo: "Resumen CFDI a CTM"
      };
      axios
        .post(this.$apiSA31 + "soluciona31/reportes/get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(
                this.datos[k].fecha_solicitud
              );
              this.datos[k].fecha_generacion = this.parseDate(
                this.datos[k].fecha_generacion
              );
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminados(
                this.datos[k].criterio
              );
            }
          }
        })
        .catch(err => {
          console.log(err);
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = [
        "Pendiente",
        "Encolado",
        "Generado Correctamente",
        "Con Errores"
      ];
      if (estatus in arr_estatus) return arr_estatus[estatus];
      else return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          if(params.lista && params.lista.length)
            return "Busqueda por Listado de " + params.tipo_consulta;
          else
            return "Periodo: " + params.periodo_de + " A " + params.periodo_a;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
    get_data_view: function() {
      if (!this.$refs.form1.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        var data = this.model;
        if (data.lista == '' || data.lista == []) {
            delete(data['lista']);
        } else {
            data['lista'] = this.get_array_lista(data['lista']);                                      
        }
        axios({
          method: "post",
          url: this.$apiSA31 + "soluciona24/reportes/rpt_resumen_cfdi_ctm/",          
          data: data
        })
          .then(response => {
            this.data_view.datos = response.data;            
          })
          .catch(error => {
            console.log(error);
            let mensaje;
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
            } else {
              mensaje =
                "Reporte demasiado grande para vista previa. Intenta con un periodo más corto";
            }

            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: ""
            });
          })
          .then(() => {
            this.$root.$dialogLoader.hide();
          });
      }
    },
    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        var data = this.model;
        if (data.lista == '' || data.lista == []) {
            delete(data['lista']);
        } else {
            data['lista'] = this.get_array_lista(data['lista']);                                      
        }
        
        axios({
          method: "post",
          url: this.$apiSA31 + "soluciona31/reportes/save_reporte/",          
          data: data
        })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text:
                "El reporte se está generando. Cuando esté listo recibirás una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          })
          .then(() => {
            this.cargar();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    downloadReporte: function(key) {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      };
      axios
        .post(this.$hostname + "s3/download_url/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text:
                "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: ""
            });
          }
        })
        .catch(error => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (
            error.response != undefined &&
            error.response.data != undefined &&
            error.response.data.mensaje != undefined
          )
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: ""
          });
          console.log(error);
        })
        .then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text:
          "¿Está seguro de eliminar el reporte con No. Proceso: " +
          idreporte +
          "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
          var datos = {
            id_reporte: idreporte
          };
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)
            .then(res => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch(error => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text:
                  "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: ""
              });
              console.log(error);
            })
            .then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon,
.theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #eeeeee;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;
}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}

.text-number {
  text-align: right;
}
</style>
